import { render, staticRenderFns } from "./PlaylistSong.vue?vue&type=template&id=1b1dc4ee&scoped=true&"
import script from "./PlaylistSong.vue?vue&type=script&lang=js&"
export * from "./PlaylistSong.vue?vue&type=script&lang=js&"
import style0 from "./PlaylistSong.vue?vue&type=style&index=0&id=1b1dc4ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1dc4ee",
  null
  
)

export default component.exports